export enum ROLE {
  USER = 'frontend_dev',
  ADMIN = 'frontend_admin',
  READONLY = 'frontend_readonly',
  CAMPAIGN = 'campaign',
}
